import { Cookies } from 'react-cookie';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocale, isRtl, useDictionary } from '../i18n';
import { isPolestar } from '../utils/globalContext';
import { useColorMode } from '../utils';
import VolvoCarsLayout from './VolvoCars';
import PolestarLayout from './Polestar';
import { hasCookiesEnabled } from '../utils';

const handleLocaleCookies = (searchParams, cookies, pageId) => {
  const languageParam = searchParams.get('language');
  const marketParam = searchParams.get('market');
  const uiLocalesParam = searchParams.get('ui_locales');

  if (languageParam && marketParam) {
    cookies.set(
      'ln-ma',
      `${languageParam.toLowerCase()}-${marketParam.toUpperCase()}`,
      { path: '/' },
    );

    if (!uiLocalesParam) {
      cookies.remove('ui_locales', { path: '/' });
    }
  }

  if (uiLocalesParam) {
    cookies.set('ui_locales', uiLocalesParam, { path: '/' });
    if (!languageParam || !marketParam) {
      cookies.remove('ln-ma', { path: '/' });
    }
  }
};

const Layout = () => {
  const cookies = new Cookies();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    handleLocaleCookies(searchParams, cookies);
  }, []);

  const locale = useLocale();

  useEffect(() => {
    const htmlTag = document.querySelector('html');
    if (htmlTag) {
      htmlTag.setAttribute('lang', locale);
    }
  }, [locale]);

  const dictionary = useDictionary();
  const isDictionaryReady = Object.keys(dictionary).length > 0 && !!locale;

  const colorMode = useColorMode();

  const Component = isPolestar ? PolestarLayout : VolvoCarsLayout;

  return (
    <Component
      isReady={isDictionaryReady}
      direction={isRtl(locale) ? 'rtl' : 'ltr'}
      colorMode={colorMode}
      hasCookiesEnabled={hasCookiesEnabled()}
    />
  );
};
export default Layout;
